import { SwitchProps, Switch as SwitchAntD } from 'antd';
import { FC } from 'react';

export const Switch: FC<SwitchProps> = (props) => {
	return <SwitchAntD {...props} />;
};
